/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

export const baseUrl = "https://ladagevandoorn.nl/assets/";

export const download = (url: string, name: string) => {
  return (
    <a href={baseUrl + "downloads/" + url} download target="_blank">
      {name}
    </a>
  );
};

export const audioPlayer = (id: number, url: string) => {
  return (
    <audio controls id={"" + id}>
      <source src={baseUrl + "audio/" + url} type="audio/mpeg" />
    </audio>
  );
};
